import { apiClient } from './client'
import type { PoiCategoryConfig } from './types'

export const categoriesApi = {
  async getAll(): Promise<PoiCategoryConfig[]> {
    const { data } = await apiClient.get<PoiCategoryConfig[]>('/v1/categories')
    return data
  },
}
